import React, { useState, Fragment, useEffect, forwardRef } from 'react'
import AddressFormComponent from './address-lookup'

export { addressFieldNames, getAddressErrors } from './validate'

const AddressInput = forwardRef(
  (
    {
      lookup,
      name,
      onChange = () => {},
      errors,
      formVariant,
      defaultAddressView,
      defaultFormValues = {},
      soleTrader,
      postcode,
      homeAddress = false,
    },
    ref,
  ) => {
    const [address, setAddress] = useState(defaultFormValues)

    useEffect(() => {
      onChange(address)
    }, [address])

    useEffect(() => {
      setAddress(defaultFormValues)
    }, [JSON.stringify(defaultFormValues)])

    return (
      <Fragment>
        <input
          type='hidden'
          id='addressInput'
          name={name}
          ref={ref}
          value={JSON.stringify(address)}
        />
        <AddressFormComponent
          lookup={lookup}
          onChange={setAddress}
          errors={errors}
          formVariant={formVariant}
          defaultAddressView={defaultAddressView}
          defaultFormValues={address}
          soleTrader={soleTrader}
          postcode={postcode}
          homeAddress={homeAddress}
          name={name}
        />
      </Fragment>
    )
  },
)

export default AddressInput
